import coverImage from "../assets/cover-a.jpg";

export default function ComponentA() {
  console.log("Component A has been created");
  console.log("\n");

  let count = 0;

  function increaseCount() {
    count++;
    console.log("Component A count:", count);
  }

  return (
    <article className="my-component">
      <img src={coverImage} alt="An inmobible rock in a greenfield" />
      <p>
        Component A count <b>{count}</b>
      </p>
      <button onClick={increaseCount}>Increase count</button>
    </article>
  );
}
